import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayInventoryEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/Inventory/`
        this.webApi = new WebApi()
    }

    async getInventories (arg) {
        const responses = await this.webApi.post(`${this.url}list`, arg)
        // console.log('responses:', responses)
        if (responses) {
            if (!responses.status_code) {
                if (!responses.error) {
                    return responses
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${responses.status_code}`)
            }
        }
        return null
    }

    async changeInventory (request) {
        const response = await this.webApi.post(`${this.url}save`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async createInventory (request) {
        const response = await this.webApi.post(`${this.url}create`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async downloadData (request) {
        const response = await this.webApi.post(`${this.url}export`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }
}
